export const Role = {
    RECRUITER: 0,
    CANDIDATE: 'candidate',
    HIRING_MANAGER: 1,
    ADMIN: 'admin',
    MANAGER: 'manager'
}